import styled from "styled-components";

export const PollOptionsContainer = styled.div`
  cursor: pointer;
  border-radius: ${({ theme }) => theme.radius["radius-xxs"].value}rem;
  padding: ${({ theme }) => theme.spacing["spacing-2"].value}rem
    ${({ theme }) => theme.spacing["spacing-4"].value}rem;
  background: ${({ theme }) =>
    theme.Color.background.brand.subtlest["default-hover"].value};
  border: 1px solid transparent;

  &:hover {
    background: ${({ theme }) =>
      theme.Color.background.brand.subtlest["default-active"].value};
    border-color: ${({ theme }) =>
      theme.Color.border["ui-border-emphasize-brand"].value};
  }
`;

export const PollContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing["spacing-2"].value}rem;
  padding: ${({ theme }) => theme.spacing["spacing-2"].value}rem
    ${({ theme }) => theme.spacing["spacing-2"].value}rem
    ${({ theme }) => theme.spacing["spacing-6"].value}rem;
  border-radius: ${({ theme }) => theme.radius["radius-xs"].value}rem;
  border: ${({ theme }) => theme.border_width["border-width-thin"].value}rem
    solid ${({ theme }) => theme.Color.border["ui-border-neutral"].value};
  box-shadow: ${({ theme }) => theme.boxShadows["box-shadow-s"]};
  width: 100%;
`;

export const ChoicesAndDurationContainer = styled.div<{ $column: boolean }>`
  display: flex;
  flex-direction: ${({ $column }) => ($column ? "column" : "row")};
  gap: ${({ theme }) => theme.spacing["spacing-2"].value}rem;
`;
